import { render, staticRenderFns } from "./CouponFilter.vue?vue&type=template&id=36f664f4&"
import script from "./CouponFilter.vue?vue&type=script&lang=js&"
export * from "./CouponFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports